import { get } from 'lodash-es';

import { getScheduleEmptyLabel, parseScheduleDatapointId } from './constants';
import { renderScheduleMentionHtml } from './render-schedule-mention-html';
import type { ScheduleItemData } from './types';

export const renderScheduleMentionValue = (dataItems: unknown, id: string): string | null => {
  const parsed = parseScheduleDatapointId(id);
  if (!parsed) return null;

  const html = renderScheduleMentionHtml((get(dataItems, id) as ScheduleItemData[] | null) ?? []);

  return html || getScheduleEmptyLabel(parsed.datapointId);
};
